import { FeatureIntroProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/FeatureIntroProperties";
export class FeatureIntroLandscapeProperties extends FeatureIntroProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
